export const LINES_COUNT_DEFAULT = 1;
